'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _ref = _jsx('div', {
    className: 'm-banner-placeholder'
});

var Banner = _react2['default'].createClass({
    displayName: 'Banner',


    /**
     */

    ANIMATION_SPEED_MS: 400,

    /**
     */

    propTypes: {
        'bannerID': _react2['default'].PropTypes.any,
        'bannerText': _react2['default'].PropTypes.string,
        'bannerLink': _react2['default'].PropTypes.string,
        'display': _react2['default'].PropTypes.bool
    },

    getDefaultProps: function getDefaultProps() {
        return {
            'bannerID': -1,
            'bannerText': '',
            'display': false
        };
    },

    getInitialState: function getInitialState() {
        var cookie = Cookie.get('hide_banner');
        var isDismissed = cookie != undefined ? cookie.split(',').some(function (e) {
            return e == this.props.bannerID;
        }, this) : false; // don't display if this specific banner was dismissed (not just any banner)
        return {
            'display': !isDismissed && this.props.display
        };
    },

    hide: function hide() {
        // set cookie to hide in the future
        var cookie = Cookie.get('hide_banner');
        cookie = cookie != undefined ? cookie + ',' + this.props.bannerID : this.props.bannerID; // store this banner's id in csv in the cookie
        Cookie.set('hide_banner', cookie);

        // hide now
        var self = this;
        $('.m-banner').animate({ opacity: 0 }, this.ANIMATION_SPEED_MS, function hideCallback() {
            self.setState({
                'display': false
            });
        });
    },

    render: function render() {
        var banner;
        var link;

        if (this.props.bannerLink !== null) {
            link = _jsx('a', {
                className: 'm-banner--link',
                href: this.props.bannerLink,
                target: '_blank'
            }, void 0, 'LEARN MORE');
        }

        if (this.state.display) {
            banner = _jsx('div', {
                className: 'm-banner'
            }, void 0, _jsx('img', {
                className: 'm-banner--notification-icon',
                src: require('./notification_icon@2x.png')
            }), _jsx('span', {
                className: 'm-banner--text'
            }, void 0, this.props.bannerText), link, _jsx('a', {
                className: 'm-banner--dismiss',
                onClick: this.hide
            }, void 0, _jsx('img', {
                className: 'm-banner--dismiss-icon',
                src: require('./x@2x.png')
            })));
        } else {
            banner = _ref;
        }

        return banner;
    }
});

module.exports = Banner;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/banner.jsx
 ** module id = 632
 ** module chunks = 0
 **/